import { gql } from '../../__generated__/gql'

export const COMMUNITY_POST_QUERY = gql(`
  query communityPost($postId: Int!, $orderBy: SortCommunityCommentsEnum) {
    communityPost(postId: $postId, orderBy: $orderBy) {
      id
      category {
        id
        title
        parentCategoryId
      }
      title
      description
      createdAt
      editedAt
      commentsCount
      votesCount
      voted
      reported
      saved
      followed
      pinned
      featured
      commentingAllowed
      wistiaId
      imageUrl
      author {
        id
        firstName
        lastName
        email
        picture
        roles
        communityProfile {
          id
          role
          postsCount
          allVotesCount
          online
          levelInfo {
            level
            progress
          }
        }
      }
      comments {
        id
        author {
          id
          firstName
          lastName
          email
          excludedFromTagging
          picture
          roles
          communityProfile {
            id
            role
            postsCount
            allVotesCount
            online
            levelInfo {
              level
              progress
            }
          }
        }
        createdAt
        editedAt
        content
        votesCount
        voted
        parentComment {
          id
          author {
            firstName
            lastName
          }
          content
        }
      }
    }
  }
`)
